import { Box, IconButton, Menu, MenuItem, styled, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from 'react';

interface NonProgressBarProps {
  name: string;
  total: number;
  color?: string;
  bgColor?: string;
  // handleOnClickPdf: () => void;
  handleOnClickExcel: () => void;
  handleOnClickInfo: () => void;
  handleOnClick?: () => void;
}

const NonProgressBar: React.FC<NonProgressBarProps> = ({
  name,
  total,
  color = '#49ab52',
  bgColor = '#c4ffc9',
  // handleOnClickPdf,
  handleOnClickExcel,
  handleOnClickInfo,
  handleOnClick
}: NonProgressBarProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (type: string) => {
    if (type === 'info') {
      handleOnClickInfo();
    } else if (type === 'excel') {
      handleOnClickExcel();
    }

    setAnchorEl(null);
  };

  return (
    <Box display="flex" my={3}>
      <Box display="flex" flexDirection="column" width="100%">
        <Box display="flex" justifyContent="space-between">
          <Typography>{name}</Typography>
          <Typography>{total > 0 ? `จำนวน ${total} คน` : 'ไม่มี'}</Typography>
        </Box>
        <BarContainer bgColor={bgColor}>
          <BarFilled percent={0} filledColor={color} />
        </BarContainer>
      </Box>
      <Box>
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        >
          <MenuItem onClick={() => handleClose('info')}>Information</MenuItem>
          <MenuItem onClick={() => handleClose('excel')}>Excel</MenuItem>
          {/* <MenuItem onClick={() => handleClose('pdf')}>PDF</MenuItem> */}
        </Menu>
      </Box>
    </Box>
  );
};

export default NonProgressBar;

type BarContainerProps = {
  bgColor: string;
};

const BarContainer = styled('div')<BarContainerProps>(({ bgColor }) => ({
  height: 5,
  width: '100%',
  backgroundColor: bgColor,
  borderRadius: 2,
  marginTop: 8
}));

type BarFilledProps = {
  percent: number;
  filledColor?: string;
};

const BarFilled = styled('div')<BarFilledProps>(({ percent, filledColor }) => ({
  height: '100%',
  width: `${percent}%`,
  backgroundColor: filledColor,
  transition: 'width 1s ease-in-out',
  borderRadius: 2
}));
